module.exports = __webpack_public_path__ + "img/icon-christmas-1.6b378167.svg";